import React, { PureComponent, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    View,
    ScrollView
} from 'react-native';

import {
    JDImage,
    JDText,
    JDTouchable,
    JDVideoPlayer
} from '@jdreact/jdreact-core-lib';
import { NavBar } from '@ltfe/ltfe-core-lib';
import { mta, mtaPV } from '../common/utils';
import st from '../style/movie.st';
import { get } from '../common/fetch';
import Loading from '../components/common/loading';
import sgmReport from '../common/sgmUtil';

class Movie extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            movieLoading: false,
            movieList: [
            ],
            info: {},//电影详情
            trailerId: props.movie?.trailerId || props.trailerId // 当前播放的视频的下标
        };
        this.click = this.click.bind(this);
    }

    static defaultProps = {
    }

    render() {
        const { movieList, currentIndex, trailerId, loading, movieLoading } = this.state;

        let { movieName, grade, actor, movie, canPreOrder } = this.props;

        movieName = decodeURI(movieName);
        actor = decodeURI(actor);
        let movieUrl, jdTrailerImgUrl;

        movieList.forEach((val) => {
            if (val.trailerId == trailerId) {
                movieUrl = val.jdTrailerUrl;
                jdTrailerImgUrl = val.jdTrailerImgUrl;
            }
        });

        return (
            <View style={ st.container }>

                {
                    loading
                        ? <ScrollView
                            showsVerticalScrollIndicator={ false }
                            stickyHeaderIndices={ [0] }
                            ref={ (scroll) => { this._scroll = scroll; } }
                            style={ { flex: 1 } }
                        >
                            <View>
                                {/* banner图片 */}
                                <View style={ st.banner }>

                                    {movieLoading && movieUrl && <VideoView
                                        movieUrl={ movieUrl }
                                        jdTrailerImgUrl={ jdTrailerImgUrl }
                                    />}

                                    {/* {
                                        movieLoading ? <JDVideoPlayer style={st.banner_video}
                                            source={
                                                {
                                                    url: movieUrl,
                                                    autoPlay: true,
                                                    imgUrl: jdTrailerImgUrl
                                                }
                                            ref={e => { this.videoView = e; }}
                                            }>
                                        </JDVideoPlayer>
                                            :
                                            <Loading />
                                    } */}
                                </View>

                                <JDTouchable onPress={ () => this.goDetail() } >
                                    <View style={ st.content }>
                                        <View style={ st.content1 }>
                                            <JDText numberOfLines={ 1 } style={ st.name }>{movieName}</JDText>
                                            {grade > 0 ? <JDText style={ st.score }>观众评分 {grade}</JDText> : <JDText style={ st.score }>暂无评分</JDText>}
                                        </View>
                                        <JDText numberOfLines={ 1 } style={ st.detail }>主演：{actor}</JDText>
                                        {
                                            !(canPreOrder == 3) &&
                                            <JDTouchable style={ st.btn_tou } onPress={ () => this.buyticket() }>
                                                <View style={ st.btn }>
                                                    <JDText style={ st.btn_text }>购票</JDText>
                                                </View>
                                            </JDTouchable>
                                        }

                                    </View>
                                </JDTouchable>
                            </View>

                            <View style={ st.foot }>
                                <JDText style={ st.title }>播放列表({this.state.movieList.length})</JDText>
                                {movieList.map((item, index) => {
                                    return (
                                        <JDTouchable onPress={ () => this.click(item.trailerId, index) } key={ index }>
                                            <View style={ st.list }>
                                                <JDImage style={ st.list_img } source={ { uri: item.jdTrailerImgUrl } }>
                                                    <JDText style={ st.list_time }>{this.trans(item.trailerDuration)}</JDText>
                                                </JDImage>
                                                <View style={ st.list1 }>
                                                    <JDText style={ [st.list_title, item.trailerId == trailerId && { color: '#E2231A' }] }>{item.trailerName}</JDText>
                                                    {/* <JDText style={st.list_number}>观看：{item.number}万</JDText> */}
                                                </View>
                                            </View>
                                        </JDTouchable>
                                    );
                                })}
                            </View>

                        </ScrollView>
                        : <Loading contentStyle={ { flex: 1, height: '100%', backgroundColor: '#fff' } } />
                }
            </View>
        );
    }

    componentDidFocus() {
        const { movieId } = this.props;
        // pv

        mtaPV('Video', `${movieId}`);
    }

    componentDidMount() {
        document.title = '视频';
        const { movieId, cityId } = this.props;
        // 页面初始化获取预告片接口

        get('getTrailerInfoVO', { movieId: movieId }).then(res => {
            const movieList = res.data;

            this.setState({
                movieList,
                loading: true,
                movieLoading: true
            });

            if(movieList && movieList.length){
                const hasEmpty = movieList.some(item =>  !item.jdTrailerImgUrl);
                if(hasEmpty){
                    sgmReport('1002', {function_id: 'getTrailerInfoVO',message:'数据未返回图片地址！'}, 3)
                }
            }
        });

        //获取影片详情
        if(cityId) {
            get('getMovieDetailVO', {
                movieId,
                cityId,
                uid: global.uuid
            }, true).then((res) => {
                const { data } = res;
                if (!data) {
                    throw new Error('No data received');
                }

                this.setState({
                    info: data
                });

                return data;
            })
            .catch((err) => {
                console.error('GetInfo error:', err);
                throw err;
            });
        }

        if(!movieId){
            sgmReport('1001', {function_id: 'getTrailerInfoVO',message:'缺少参数movieId'}, 3)
        }
    }

    // 数字格式化函数
    trans(num) {
        if (num <= 60 && num <= 9) {
            return '0' + num + '秒';
        } else {
            let fen = parseInt(num / 60);

            if (fen < 10) {
                fen = '0' + fen;
            } else {
                fen = fen;
            }
            let miao = num % 60;

            if (miao < 10) {
                miao = '0' + miao;
            } else {
                miao = miao;
            }

            return fen + ':' + miao;
        }
    }

    // 点击切换视频函数
    click(trailerId, index) {
        const { movieId, jSkuId, from } = this.props;

        this.setState({
            trailerId,
            movieLoading: false
        }, () => {
            this.setState({
                movieLoading: true
            });
        });

        let _jSkuId = jSkuId;

        if(from && from == 'h5'){
            _jSkuId = this.state.info.jSkuId
        }

        // 电影票sku_movieID_视频id_顺序（列表的排序从1开始）
        mta('VideoItem', 'Video', `${_jSkuId}_${movieId}_${trailerId}_${index + 1}`);
    }

    // 点击购票函数
    buyticket() {
        const { movieId, jSkuId, from } = this.props;

        const hostUrl = location.origin;

        let _jSkuId = jSkuId;

        if(from && from == 'h5'){
            _jSkuId = this.state.info.jSkuId
        }

        window.location.replace(`${hostUrl}/movieSchedule?movieId=${movieId}`);
        //  this.context.router.toMovieSchedule({ movieId: movieId });

        // 电影票sku_movieID
        mta('VideoMovBuy', 'Video', `${_jSkuId}_${movieId}`);
    }

    // 点击影片详情
    goDetail() {
        const { movieId, jSkuId, from } = this.props;
        // this.videoView.pause();

        let _jSkuId = jSkuId;

        if(from && from == 'h5'){
            _jSkuId = this.state.info.jSkuId
        }

        this.context.router.pop();
        // 电影票sku_movieID
        mta('VideoMovInfo', 'Video', `${_jSkuId}_${movieId}`);
    }
}

class VideoView extends Component {
    render() {
        const { movieUrl } = this.props;

        return <video style={ st.banner_video } controls autoPlay src={ movieUrl } name="media" />;
    }

    componentWillUnmount() {
        this.videoView && this.videoView.pause();
    }
}

Movie.contextTypes = {
    router: PropTypes.object
};

const select = (state) => {
    const { lbsCity, cur_city, label } = state.index;

    return {
        lbsCity,
        cur_city,
        label
    };
};

export default connect(select, null, null, { withRef: true })(Movie)
;
